import React, { useState } from 'react';

import { Modal } from 'app-components';
import { FormattedMessage } from 'react-intl';

import RadioButtons from '@lib/inputs/RadioButtons';

import CapitalizedButton from '../components/common/CapitalizedButton';
import { ModalContextType } from '../../../contexts/modalContext';

interface IModalProps extends ModalContextType {
    coverageDate1: string;
    coverageDate2: string;
    onContinue: (coverageDate: string) => void;
}

function SelectCoverageDateModal({ coverageDate1, coverageDate2, onContinue, closeModal }: IModalProps) {
    const [coverageDate, setCoverageDate] = useState(coverageDate1);

    const onClose = () => {
        closeModal('selectCoverageDate');
    };

    const onContinueHandler = () => {
        closeModal('selectCoverageDate');
        onContinue(coverageDate);
    };

    return (
        <Modal id="selectCoverageDateModal">
            <Modal.Header
                id="SelectCoverageDateModalHeader"
                titleId="customGrouping.selectCoverageDate.header"
                onHide={onClose}
            />
            <Modal.Body id="SelectCoverageDateModalBody">
                <RadioButtons
                    legend={{
                        legendText: (
                            <FormattedMessage id="customGrouping.selectCoverageDate.legend" />
                        ),
                    }}
                    label={{
                        isLabelVisible: true,
                        showRequiredIcon: true,
                        ulClass: ['gap-5'],
                    }}
                    inputData={{
                        name: 'selectCoverageDate',
                        id: 'selectCoverageDate',
                        options: [
                            {
                                value: coverageDate1,
                                text: new Date(coverageDate1).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }),
                            },
                            {
                                value: coverageDate2,
                                text: new Date(coverageDate2).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }),
                            },
                        ],
                        type: 'radio_buttons',
                        value: coverageDate,
                        inputRequired: true,
                    }}
                    inputActions={{
                        handleFieldChange: val => setCoverageDate(val),
                    }}
                />
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton
                    id="selectCoverageDateModalContinueButton"
                    onClickHandler={onContinueHandler}
                    variant="primary"
                    labelId="button.continue"
                />
            </Modal.Controls>
        </Modal>
    );
}

export default SelectCoverageDateModal;
